import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Cliente } from 'src/app/interfaces/cliente';
import { Direccion } from 'src/app/interfaces/direccion';
import { ClienteService } from 'src/app/service/cliente.service';
import { DireccionService } from 'src/app/service/direccion.service';
import { DireccionFormComponent } from '../direccion-form/direccion-form.component';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.css']
})
export class PerfilComponent implements OnInit {
  public cliente: Cliente;
  public direcciones:Direccion[]=Array<Direccion>();
  constructor(private clienteService: ClienteService,private direccioneService: DireccionService, private dialog: MatDialog) {
    this.cliente={
      id: 0,
      email: '',
      password: '',
      token: '',
      estado: 0,
      dni: 0,
      nombres: ''};
      clienteService.getbytoken().then((item:Cliente)=>{
        this.cliente=item;
        console.log(item);
      });
      direccioneService.getByCliente().then((item:any)=>{
        this.direcciones=item;
      })
   }

  ngOnInit(): void {
  }

  cargar(){
    this.clienteService.put(this.cliente);
  }
  newDir(id:number){
    let dialogRef = this.dialog.open(DireccionFormComponent, {
      data: {id: 0},
      maxHeight: '90vh'
    });
  }
}
